module.exports = {"forumSectionDescription":""}


//////////////////
// WEBPACK FOOTER
// ./src/lang/mx/public/shared/views/healthy-community.json
// module id = 592
// module chunks = 117